import { useEffect, useState } from 'react';

const getWindowDimensions = () => {
  const { innerHeight: height, innerWidth: width } = window;
  return {
    height,
    width
  };
};

export const useGetDimensions = () => {
  const [dimensions, setDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    const handleResize = () => {
      setDimensions(getWindowDimensions());
    };
    window.addEventListener('resize', handleResize);
    return window.removeEventListener('resize', handleResize);
  }, []);

  return dimensions;
};
